<style scoped>
.drop-element {
  color: #cccccc;
  text-align: center;
  width: 100%;
}
.empty-emoji {
  font-size: 80px;
  display: block;
}
.drop.over {
  border: 0px dashed #cccccc;
}
</style>
<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-container grid-list-md fluid ma-0 pa-0>
      <v-layout row wrap>
        <v-flex
          v-for="(element, index) in elements"
          :key="index"
          :class="element.className"
        >
          <form-element
            :element="element"
            :index="index"
            :display="'view'"
            :key="element.id"
          ></form-element>
        </v-flex>
      </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import Element from "@/components/charts/form/builder/element.vue";

const formElementSchema = {
  id: null,
  type: "input",
  name: null,
  column: "",
  label: "Enter Your Field Label",
  hint: null,
  model: null,
  models: [],
  show: false,
  placeholder: null,
  switchable: false,
  style: "",
  className: "",
  properties: [],
  required: false,
  listType: null,
  sql: null,
  json: null,
  items: [],
  hasList: false,
  color: "",
  onClickFunctionEnabled: false,
  defaultColumns: "",
  functionType: "",
  functionValue: "",
  updateColumns: "",
  successMessage: "",
  errorMessage: "",
  hasSubChart: false,
  subChartValue: null,
  mask: null,
  namespace: null,
  folder: null,
  designType: "outline",
  multiple: false
};

function createElements(elements) {
  let results = [];
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    results.push({ ...formElementSchema, ...element });
  }
  return results;
}
export default {
  props: ["chart", "form"],
  data: function () {
    return {
      valid: true,
      elements: [],
      layout: [],
    };
  },
  components: {
    "form-element": Element,
  },
  methods: {},
  computed: {},
  mounted: function () {
    const that = this;
    const form = this.form;
    if (form) {
      that.elements = createElements(form.elements);
      // console.log("elements", that.elements);
      form.getElements = function () {
        return that.elements;
      };

      form.getElementValues = function () {
        const elements = that.elements;
        let values = {};
        for(let i = 0; i < elements.length; i++) {
          const element = elements[i];
          try {
            const id = element.id;
            const model = element.model;

            values[id] = model;

          } catch(error) {

          }
        }
        return values;
      };
    }
  },
  beforeDestroy() {},
};
</script>
